<template>
    <div class="tw-loading"></div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';

    @Component({})

    export default class LoadingSplash extends TicketWidgetComponent {}
</script>